import { message } from "antd";

import * as ActionTypes from "../action-types";

import * as API from "../../api";

import { setLoadingEmployer, unsetLoadingEmployer } from "./style";

export const get_all_employer_request = () => (dispatch) => {
  dispatch(setLoadingEmployer());

  API.getAllEmployer()
    .then((info) => {
      const { status, employers, msg } = info;

      if (status === 200) {
        dispatch(get_all_employer_success(employers));
        message.success(msg);
      } else {
        message.error(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingEmployer());
    });
};

const get_all_employer_success = (employer) => {
  return {
    type: ActionTypes.EMPLOYER_GET_ALL,
    employer,
  };
};

export const create_employer =
  ({ name, coid, position, contact, email, password, createdBy }, cb) =>
  (dispatch) => {
    API.createEmployer({
      name,
      coid,
      position,
      contact,
      email,
      password,
      createdBy,
    })
      .then((data) => {
        const { status, employer, msg } = data;

        if (status === 200) {
          dispatch(create_employer_success(employer));
          message.success("Employer Created successfully");
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        cb();
      });
  };

export const create_employer_success = (employer) => {
  return {
    type: ActionTypes.CREATE_EMPLOYER,
    employer,
  };
};

export const update_employer_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingEmployer());

  API.updateEmployer(items)
    .then((data) => {
      if (data && data.status && data.employer) {
        const { status, employer, msg, remarkCount } = data;
        if (status === 200) {
          dispatch(update_employer_success(employer));
          dispatch(
            update_remarkcount_employer_success({
              refid: employer.memid,
              remarkCount,
            })
          );
          message.success("Update Employer successfully");
        } else {
          message.warning(msg);
        }
      } else {
        message.error("Unexpected response from the server");
      }
    })
    .catch((error) => {
      console.error("Error in Update Employer :", error.message);
      message.error("Failed to update employer. Please try again later.");
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingEmployer());
    });
};

const update_employer_success = (employer) => {
  return {
    type: ActionTypes.UPDATE_EMPLOYER,
    employer,
  };
};

export const get_employer_list_no_coid_request = () => (dispatch) => {
  dispatch(setLoadingEmployer());

  API.getEmployerListNoCoid()
    .then((info) => {
      const { status, employers, msg } = info;
      if (status === 200) {
        dispatch(get_employer_list_no_coid_success(employers));
        message.success("Successfully get the employers data with no company");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingEmployer());
    });
};

const get_employer_list_no_coid_success = (employer) => {
  return {
    type: ActionTypes.GET_EMPLOYER_LIST_NO_COID,
    employer,
  };
};

export const update_remarkcount_employer_success = (remark) => {
  return {
    type: ActionTypes.UPDATE_REMARKCOUNT_EMPLOYER,
    remark,
  };
};
